import React from "react";

const REFERRALS = [
  {
    quote:
      "I've known one of the founders of Team Magis for a lifetime: a genuine, skilled person who's always ready to take responsibility. In the sports world, we used to call him \u201CBlack Hole\u201D — if the ball came his way and there was an opening, he'd shoot without hesitation. That trait still defines him today: decisiveness, determination, and confidence in his abilities. When he or his team know how to do something, they just do it — without hesitation, with the same drive as always.",
    company: "AMMEGA",
  },
  {
    quote:
      "Recently, I had the opportunity to work with Mattia and the team he leads, witnessing firsthand how the value of people, combined with well-established methods of activity governance, supports the achievement of set objectives — especially in the context of strategic transformation, which is an essential foundation for pursuing innovative and high-performing growth.",
    company: "A2A",
  },
  {
    quote:
      "I had the opportunity to work side by side with one of the founders of Magis. From the very beginning, I was struck by his initiative and the dedication with which he tackled every challenge, always pushing beyond the ordinary to achieve truly exceptional results. Over time, this quality has not only remained but has grown even stronger: the drive to go beyond limits, to keep improving, and to never settle. In this sense, \u201CMagis\u201D is not just a name, but the word that best captures the essence of this reality.",
    company: "VIVIBANCA",
  },
  {
    quote:
      "The program sparked people's creativity and enthusiasm, inviting them to actively contribute to a delicate phase of change management. Ideas to be transformed into innovations, out-of-the-box thinking, and a touch of challenge helped influence everyone's mindset, offering a shift in perspective: change turned from an obstacle into an opportunity. Working with Mattia has been a journey in itself — once we found the right rhythm and tuned in properly, we began to truly understand each other and discover the best way to collaborate.",
    company: "Bonelli Erede",
  },
  {
    quote:
      "I recently worked with a founder of the Magis team on our strategy, focusing in particular on Vision and Mission. What struck me immediately was their practical approach: every idea is backed by data, feasible, and immediately applicable. They never settle for what has already been done. Even when something works, they are always looking for one step further, a different way to solve problems. This requires focus and dedication, but it leads to tangible and measurable results.",
    company: "Laurini Officine Meccaniche",
  },
];

export const Referrals = () => {
  return (
    <section
      id="referrals"
      data-testid="referrals-section"
      className="relative bg-brand-teal text-white py-24 md:py-40 overflow-hidden grain"
    >
      <div className="absolute -top-40 left-1/3 w-[500px] h-[500px] rounded-full bg-[#154247] blur-3xl opacity-50 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-3">
            <span className="overline text-[#2EC4B6]">— In our clients' words</span>
          </div>
          <div className="md:col-span-9">
            <h2
              className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.05]"
              data-testid="referrals-heading"
            >
              The strongest case<br />
              <span className="text-white/50">we'll ever make</span> isn't ours.
            </h2>
          </div>
        </div>

        {/* Staggered editorial grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {REFERRALS.map((r, i) => {
            const layouts = [
              "md:col-span-7",
              "md:col-span-5",
              "md:col-span-5",
              "md:col-span-7",
              "md:col-span-12",
            ];
            return (
              <figure
                key={r.company}
                data-testid={`referral-${i}`}
                className={`${layouts[i]} bg-white/[0.04] border border-white/10 hover:border-[#2EC4B6]/40 hover:bg-white/[0.06] transition-all duration-500 p-8 md:p-10 group`}
              >
                <div
                  className="font-display text-6xl md:text-7xl text-[#2EC4B6] leading-none mb-4 -ml-1 group-hover:scale-110 origin-left transition-transform duration-500"
                  aria-hidden="true"
                >
                  &ldquo;
                </div>
                <blockquote className="font-display-medium text-base md:text-lg leading-relaxed text-white/90 mb-8">
                  {r.quote}
                </blockquote>
                <figcaption className="border-t border-white/10 pt-5">
                  <div className="overline text-[#2EC4B6]">{r.company}</div>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Referrals;
